import React from 'react';
import Icon from '../AppIcon';

const NeighborsUserItem = ({ userItem, primaryActionLabel, onPrimaryAction, secondaryActionLabel, onSecondaryAction }) => {
  return (
    <div className="flex items-center justify-between gap-3 p-3 rounded-md border border-border bg-card">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-10 h-10 rounded-full bg-muted overflow-hidden flex items-center justify-center border border-border">
          {userItem?.avatarUrl ? (
            <img src={userItem.avatarUrl} alt={userItem.username} className="w-full h-full object-cover" />
          ) : (
            <Icon name="User" size={18} className="text-muted-foreground" />
          )}
        </div>
        <div className="min-w-0">
          <div className="text-sm font-medium text-foreground truncate">{userItem?.username}</div>
          <div className="text-xs text-muted-foreground caption mt-0.5">{String(userItem?.createdAt || '').slice(0, 10)}</div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {primaryActionLabel ? (
          <button
            type="button"
            onClick={onPrimaryAction}
            className="px-3 py-2 rounded-md bg-muted/40 text-foreground hover:bg-muted transition-gaming text-sm"
          >
            {primaryActionLabel}
          </button>
        ) : null}
        {secondaryActionLabel ? (
          <button
            type="button"
            onClick={onSecondaryAction}
            className="px-3 py-2 rounded-md bg-destructive text-destructive-foreground hover:bg-destructive/90 transition-gaming text-sm"
          >
            {secondaryActionLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default NeighborsUserItem;
